var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.948 4.2H3.433l6.392 8.553L3.307 19.8h2.217l5.292-5.721 4.276 5.721h5.514l-6.74-9.018L19.954 4.2h-2.218l-4.86 5.255zm6.96 13.968L6.69 5.832h1.44l9.219 12.336z",
  clipRule: "evenodd"
})));
export default SvgX;